(function () {
  var form = document.querySelector('[data-inquiry-form]');
  if (!form) return;

  var steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
  var progress = form.querySelector('[data-progress]');
  var backBtn = form.querySelector('[data-back]');
  var nextBtn = form.querySelector('[data-next]');
  var submitting = false;
  var submitted = false;
  var submitBtn = form.querySelector('[data-submit]');
  var submitError = form.querySelector('[data-submit-error]');
  var confirmation = document.querySelector('[data-confirmation]');
  var current = 0;

  // A18. Inquiry funnel events.
  //
  // Nothing in the four-step inquiry reached the dataLayer before this, so the
  // GTM container (GTM-PDJ6ZMPJ) could see a visitor add a tour to the cart
  // but could not see a bespoke inquiry start, advance or succeed - which is
  // the higher-value of the two paths. These push to the SAME window.dataLayer
  // that snippets/ultimate-datalayer.liquid already uses, so there is no
  // second mechanism and no second container.
  //
  // WHAT IS SENT: an event name, the step number, the total number of steps
  // and the form's own source label. Nothing else. No name, no email, no
  // WhatsApp number, no ages, no dates, no dietary or food text and no free
  // text from the details field ever enters an event, and the payload is
  // built from a fixed literal below rather than read off the form, so a
  // field added later cannot start leaking into analytics by accident.
  function pushEvent(name, extra) {
    if (!window.dataLayer) window.dataLayer = [];
    var payload = {
      event: name,
      form_id: 'bespoke_inquiry',
      form_source: form.getAttribute('data-source') || '',
      step_count: steps.length
    };
    if (extra && typeof extra.step === 'number') payload.step = extra.step;
    window.dataLayer.push(payload);
  }

  var started = false;
  function markStarted() {
    if (started) return;
    started = true;
    pushEvent('inquiry_start', { step: 1 });
  }
  form.addEventListener('change', markStarted, { once: true });
  form.addEventListener('input', markStarted, { once: true });

  var errorFields = {
    dates: 'dates',
    party: 'party_size',
    ages: 'ages',
    name: 'name',
    email: 'email'
  };

  function showError(key, show) {
    var el = form.querySelector('[data-error-for="' + key + '"]');
    if (el) el.hidden = !show;
    var field = form.elements[errorFields[key]];
    if (field) {
      if (show) {
        field.setAttribute('aria-invalid', 'true');
      } else {
        field.removeAttribute('aria-invalid');
      }
    }
  }

  function validateStep(index) {
    var ok = true;
    var firstBad = null;
    if (index === 0) {
      var dates = form.elements.dates.value.trim();
      var flexible = form.querySelector('[data-flexible]').checked;
      var party = form.elements.party_size.value;
      var ages = form.elements.ages.value.trim();
      var datesOk = dates !== '' || flexible;
      var partyOk = party !== '';
      var agesOk = ages !== '';
      showError('dates', !datesOk);
      showError('party', !partyOk);
      showError('ages', !agesOk);
      ok = datesOk && partyOk && agesOk;
      if (!datesOk) firstBad = form.elements.dates;
      else if (!partyOk) firstBad = form.elements.party_size;
      else if (!agesOk) firstBad = form.elements.ages;
    }
    if (index === 3) {
      var name = form.elements.name.value.trim();
      var email = form.elements.email.value.trim();
      var nameOk = name !== '';
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      showError('name', !nameOk);
      showError('email', !emailOk);
      ok = nameOk && emailOk;
      if (!nameOk) firstBad = form.elements.name;
      else if (!emailOk) firstBad = form.elements.email;
    }
    if (!ok && firstBad) firstBad.focus();
    return ok;
  }

  // moveFocus is false on the first paint. Focusing the legend scrolls it into
  // view, and on pages where the form sits at the foot that lands the visitor
  // at the form instead of the top of the page.
  function render(moveFocus) {
    steps.forEach(function (step, i) {
      step.hidden = i !== current;
    });
    progress.hidden = false;
    progress.textContent = 'Step ' + (current + 1) + ' of ' + steps.length;
    backBtn.hidden = current === 0;
    nextBtn.hidden = current === steps.length - 1;
    submitBtn.hidden = current !== steps.length - 1;
    if (!moveFocus) return;
    var legend = steps[current].querySelector('.t2-inquiry__legend');
    if (legend) legend.focus();
  }

  nextBtn.addEventListener('click', function () {
    if (!validateStep(current)) return;
    markStarted();
    current = Math.min(current + 1, steps.length - 1);
    render(true);
    pushEvent('inquiry_step', { step: current + 1 });
  });

  backBtn.addEventListener('click', function () {
    current = Math.max(current - 1, 0);
    render(true);
  });

  var flexibleBox = form.querySelector('[data-flexible]');
  flexibleBox.addEventListener('change', function () {
    if (flexibleBox.checked) showError('dates', false);
  });

  // Turnstile, rendered explicitly so the token arrives on a callback rather
  // than being polled for. A visitor can submit before the token lands, so
  // waitForToken resolves the moment it does instead of failing the attempt.
  var turnstileKey = form.getAttribute('data-turnstile-key');
  var turnstileToken = '';
  var tokenWaiters = [];

  function deliverToken(token) {
    turnstileToken = token || '';
    var waiting = tokenWaiters;
    tokenWaiters = [];
    waiting.forEach(function (resolve) { resolve(turnstileToken); });
  }

  if (turnstileKey) {
    var slot = form.querySelector('[data-turnstile-slot]');
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.onload = function () {
      if (!window.turnstile) return;
      window.turnstile.render(slot, {
        sitekey: turnstileKey,
        callback: deliverToken,
        'expired-callback': function () { turnstileToken = ''; },
        'error-callback': function () { deliverToken(''); }
      });
    };
    document.head.appendChild(s);
  }

  function waitForToken(maxMs) {
    if (!turnstileKey) return Promise.resolve('');
    if (turnstileToken) return Promise.resolve(turnstileToken);
    return new Promise(function (resolve) {
      var settled = false;
      function finish(token) {
        if (settled) return;
        settled = true;
        resolve(token || '');
      }
      tokenWaiters.push(finish);
      setTimeout(function () { finish(''); }, maxMs);
    });
  }


  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (submitting || submitted) return;
    if (!validateStep(3)) return;
    submitting = true;
    submitError.hidden = true;
    submitBtn.disabled = true;
    var restoreLabel = submitBtn.textContent;
    if (turnstileKey && !turnstileToken) submitBtn.textContent = submitBtn.getAttribute('data-sending-label') || restoreLabel;

    var interests = Array.prototype.slice
      .call(form.querySelectorAll('input[name="interests"]:checked'))
      .map(function (el) { return el.value; });

    var payload = {
      name: form.elements.name.value.trim(),
      email: form.elements.email.value.trim(),
      dates: form.elements.dates.value.trim(),
      dates_flexible: form.querySelector('[data-flexible]').checked,
      party_size: form.elements.party_size.value,
      ages: form.elements.ages.value.trim(),
      interests: interests,
      food_preferences: form.elements.food_preferences.value.trim(),
      dietary_requirements: form.elements.dietary_requirements.value.trim(),
      additional_details: form.elements.additional_details.value.trim(),
      whatsapp: form.elements.whatsapp.value.trim(),
      website: form.elements.website.value,
      page: window.location.href,
      source: form.getAttribute('data-source') || ''
    };

    waitForToken(20000)
      .then(function (token) {
        payload.turnstile_token = token;
        return fetch(form.action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('bad status ' + res.status);
        return res.json();
      })
      .then(function (result) {
        if (!result || result.ok !== true) throw new Error('inquiry not accepted');
        submitted = true;
        submitting = false;
        form.hidden = true;
        confirmation.hidden = false;
        confirmation.focus();
        if (!payload.website) {
          pushEvent('inquiry_submitted', { step: steps.length });
          if (window.ETTLeadTracking) window.ETTLeadTracking.record(form, 'journey');
        }
      })
      .catch(function () {
        submitting = false;
        submitError.hidden = false;
        submitBtn.disabled = false;
        submitBtn.textContent = restoreLabel;
      });
  });

  render();
})();
